import {
  PRICING_SET_ACTIVE_SORT_TAB,
  PRICING_SET_CATALOGS,
  PRICING_SET_CATALOGS_LOADING,
  PRICING_SET_CUSTOM_GROUP_NAMES,
  PRICING_SET_NOTIFICATION,
  PRICING_SET_SEARCH_TEXT,
  PRICING_SHOW_PRICING_POPUP,
  PRICING_SET_FEATURES_LIST,
  PRICING_SET_FEATURES_RECEIVED,
  PRICING_SET_FEATURES_COLUMNS, PRICING_SET_FEATURE_GROUPS_CHECKED, PRICING_SET_GROUP_NAME, PRICING_SET_EDITED_FEATURES,
} from "../../constants/actionTypes";
import {getLocalStorageItem} from "../../utilities/storageFunctions";

const initialState = {
  isModal: false,
  pricingSearchText: "",
  priceListActiveSortTab: "name",
  pricingGroupName: "",
  pricingPopupType: "",
  pricingNotification: {
    visible: false,
    type: "success", // "pending", "success", "error"
    text: "", // string
  },
  pricingCustomGroupNames: {}, // groupName: ""
  pricingCatalogsLoading: false,
  pricingCatalogs: [], // groupName: ""
  pricingFeaturesReceived: false,
  pricingFeaturesList: [], // {dbFeature}
  pricingEditedFeatures: {}, // {featureDefinitionId: {name: "Test", description: "123"}}
  pricingFeaturesColumns: getLocalStorageItem("pricingFeaturesColumns") || ["name", "description", "price", "cost"],
  pricingFeatureGroupsChecked: getLocalStorageItem("pricingFeatureGroupsChecked") || ["Cutouts", "Backsplash", "Top Cabinet",
    "Countertop", "Sink"],
  pricingUpdatesCount: [], // to save tasks
};

export default function (state = initialState, action) {
  switch (action.type) {
    case PRICING_SET_SEARCH_TEXT:
    case PRICING_SET_ACTIVE_SORT_TAB:
    case PRICING_SET_GROUP_NAME:
    case PRICING_SET_CATALOGS_LOADING:
    case PRICING_SET_CATALOGS:
    case PRICING_SET_FEATURES_RECEIVED:
    case PRICING_SET_FEATURES_LIST:
    case PRICING_SET_EDITED_FEATURES:
    case PRICING_SET_FEATURES_COLUMNS:
    case PRICING_SET_FEATURE_GROUPS_CHECKED:
      return {...state, ...action.payload};
    case PRICING_SHOW_PRICING_POPUP:
      return {...state, pricingPopupType: action.payload.pricingPopupType || state.pricingPopupType};
    case PRICING_SET_CUSTOM_GROUP_NAMES:
      return {...state, pricingCustomGroupNames: {
          ...state.pricingCustomGroupNames,
          [action.payload.groupName]: action.payload.customGroupName
        }};
    case PRICING_SET_NOTIFICATION:
      return {...state, pricingNotification: {
          visible: action.payload.visible,
          type: action.payload.type || state.pricingNotification.type,
          text: action.payload.text || state.pricingNotification.text,
        }};
    default:
      return state;
  }
}
